<script setup lang="ts">
defineProps<{
  label: stringI18n
  value: string | None
}>()
</script>

<template>
  <UiLine :label :value="value" col>
    <template #default="{ emClass }">
      <span class="_row _wrap _gap1 _ctrY _hm28"
        ><em :class="emClass">{{ value }}</em>
        <LazyButtonCopy :copy="() => value" class="_c4" />
      </span>
    </template>
  </UiLine>
</template>
